import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import $http from '$http';

export default {
    mixins: [services],
    data() {
        return {
            loading: false,
            AddDialogVisible: false,
            agent: '',
            school: '',
            title: '',
            form: {},
            auditFormData: this.getAuditData(),
            ClassNum: 1,
            status: [{
                "name": "审核通过",
                "id": "6"
            }, {
                "name": "审核不通过",
                "id": "11"
            }],
            isAudit: false,

        }
    },
    methods: {
        getAuditData() {
            return cloneDeep({
                OrderId: '',
                OrderStatus: '',
                AuditRemark: ""
            });
        },


        //初始化数据
        initData() {
            this.agent = ''
            this.school = ''
            this.isAudit = false
            this.loading = false
            this.auditFormData = this.getAuditData()
            this.form = {}
        },
        show(options) {
            this.initData();
            this.AddDialogVisible = true
            this.title = options.title
            this.getList(options.OrderId)
            if (options.isAudit) {
                // 审核
                this.auditFormData.OrderId = options.OrderId
                this.isAudit = options.isAudit
            }
        },

        submit() {
            // 新增
            let rule = [{
                name: "审核意见",
                value: this.auditFormData.OrderStatus,
                required: true,
                msg: '请选择审核意见'
            }, {
                name: "审核备注",
                value: this.auditFormData.AuditRemark,
                required: true,
            }]

            var flag = util.checkForm({
                ele: this,
                rules: rule
            });

            if (!flag) {
                return;
            }
            if (this.isAudit) {
                // 审核
                this.OrderSendLessonAuditByFinance()
            }


        }
    },

}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/addSendLessonView/vm.js